import { useEffect } from 'react'

import { studentController } from '@/controller/student.controller'
import useRepository from '@/hooks/useRepository'
import { LessonGroupService } from '@/page/Lesson/_service'
import commonRepo from '@/repository/common.repo'
import { RouteName } from '@/router'
import StudentGroupAccordionService from '@/service/StudentGroupAccordion.service'

export const useSetStudentGroups = () => {
  const lessonGroupService = useRepository(LessonGroupService)
  const studentGroupAccordionService = useRepository(
    [StudentGroupAccordionService, RouteName.lesson],
    RouteName.lesson,
  )

  useEffect(() => {
    if (commonRepo.academy) {
      // 학생 리스틀를 조회 -> then 이후에는 케싱 데이터를 사용
      studentController.fetchStudentGroups({ serviceType: 'SCIENCEFLAT' }).then(() => {
        studentGroupAccordionService.initStudentGroup()
        lessonGroupService.fetchStudentGroups()
      })
    }
  }, [commonRepo.academy, commonRepo.academy?.studentCount])
}
